import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api/index.js';

Vue.use(Vuex)

function loginErrorHandler(error, successCallback) {
  let message = '';
  if (error.code === 0) {
    console.log('登录成功');
    successCallback && successCallback();
  } else if (error.code === 1) {
    message = '用户名或密码错误';
  } else if (error.code === 2) {
    message = '用户不存在，请先注册';
  } else if (error.code === 3) {
    message = '您输入的验证码错误';
  } else if (error.code === 4) {
    message = '您还未注册，请先注册';
  } else if (error.code === 5) {
    message = '您的账号已被禁用，请联系客服';
  } else if (error.code === 6) {
    message = '用户名或密码错误';
  } else if (error.code === 7) {
    message = '用户名或密码错误';
  } else if (error.code === 8) {
    message = '您尚未设置本网站的密码，请您设置密码';
  } else if (error.code === 9) {
    message = '用户名或密码错误';
  } else if (error.code === 10) {
    message = '登录失败，请您重新登录。';
  } else if (error.code === 11) {
    message = '用户密码超过90天未修改，请先修改密码。';
  } else {
    message = '用户未登录';
  }
  message && Vue.prototype.$message.error(message);
}

export default new Vuex.Store({
  state: {
    sexDict: {
      0: '女',
      1: '男',
    },
    gradeDict: {
      'k10': '高一',
      'k11': '高二',
    },
    paperTypeList: [
      { id: '10', label: '交通运输' },
      { id: '11', label: '体育运动' },
      { id: '12', label: '艺术与人文' },
      { id: '13', label: '金融经济' },
      { id: '14', label: '工程与科技' },
      { id: '5', label: '自然科学' },
      { id: '6', label: '日常生活' },
      { id: '7', label: '学习生活' },
      { id: '15', label: '环境与生态' },
      { id: '16', label: '健康与医疗' },
      { id: '8', label: '其他' }
    ],
    // paperTypeList: [
    //   { id: '0', label: '交通' },
    //   { id: '1', label: '体育' },
    //   { id: '2', label: '艺术' },
    //   { id: '3', label: '金融' },
    //   { id: '4', label: '工程' },
    //   { id: '5', label: '自然科学' },
    //   { id: '6', label: '日常生活' },
    //   { id: '7', label: '学习生活' },
    //   { id: '8', label: '其他' }
    // ],
    questionTypeDict: {
      'JUDGMENT': '判断题',
      'SINGLE_CHOICE': '单选题',
      'MULTIPLE_CHOICE': '多选题',
    },
    activityActive: {},
    userInfo: {},
    loginState: -10,
  },
  getters: {
    isLogined(state) {
      let token = (state.userInfo.accessToken || {}).token || state.userInfo.token || '';
      return token ? true : false
    },
    paperTypeDict(state) {
      let result = {}
      state.paperTypeList.forEach(v => {
        result[v.id] = v.label
      })
      return result
    },
  },
  mutations: {
    setUserInfo(state, params) {
      params = params || {}
      if (!params.phone_ && params.phone) {
        params.phone_ = params.phone.replace(
          /(\d{3})\d{4}(\d{4})/,
          "$1****$2"
        );
      }
      state.userInfo = params || {}
      let token = (params.accessToken || {}).token || params.token || '';
      localStorage.setItem('userInfo', JSON.stringify(params));
      localStorage.setItem('gatewayApiToken', token);
      localStorage.setItem('token', token);
      // localStorage.setItem('STU_UID', params.stuUid || '');
    },
    setLoginState(state, params) {
      state.loginState = params
    },
    setActivityActive(state, params) {
      state.activityActive = params || {}
    },
  },
  actions: {
    logout({ commit }) {
      return api.logout().finally(() => {
        commit('setUserInfo', {})
      })
    },
    getCurrentUser({ commit }) {
      let token = localStorage.getItem('token');
      return api
        .getCurrentUser()
        .then((res) => {
          res = res || {};
          !res.accessToken && (res.accessToken = {
            refreshToken: token,
            token: token,
          });
          commit('setUserInfo', res)
        })
        .catch((err) => {
          console.log('getCurrentUser err:', err);
          commit('setUserInfo', {})
        });
    },
    islogin({ commit }) {
      return api
        .islogin()
        .then((res) => {
          console.log('islogin res:', res);
          let info = res.info;
          commit('setUserInfo', info)
          if (String(res.data) === '0') {
            localStorage.setItem('gatewayApiToken', info.accessToken.token); // 存储个人中心token
          } else if (String(res.data) === '-2') {
            //
          } else {
            localStorage.removeItem('gatewayApiToken'); // 没有登录删除 gatewayApiToken
            sessionStorage.clear();
          }
          loginErrorHandler(info);
        })
        .catch((err) => {
          console.log('islogin err:', err);
        });
    }
  },
  modules: {
  }
})
